import { styled } from '@pata-app/themes';

export const TilesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  row-gap: ${({ theme }) => theme.core.sizing[4]}px;
  column-gap: 50px;

  margin-top: 60px;

  padding: 0 ${({ theme }) => theme.core.sizing[4]}px;

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    column-gap: 160px;
    padding: 0;
  }
`;

export const BackgroundColor = styled.div`
  padding: 150px 0;

  background: ${({ theme }) => theme.core.colors.primary.green.medium};
  color: ${({ theme }) => theme.core.colors.greyscale.white};

  section {
    margin: 0;
  }

  h2 {
    text-align: center;
  }
`;

export const ConditionsContainer = styled.div`
  margin-top: ${({ theme }) => theme.core.sizing[5]}px;
`;
